// @flow
import PageDetail from 'components/page/PageDetail';
import { connect } from 'react-redux';
import { fetchPageDetail, fetchPageDetailPreview } from 'actions/pageActions';

import type { DispatchType, StateType } from 'types/Actions';
import type { DispatchProps, StateProps } from 'components/page/PageDetail';

export default connect(
  (state: StateType): StateProps => ({
    title: state.pageDetailState.title ? 
      state.pageDetailState.title : state.pageDetailPreviewState.title,
    content: state.pageDetailState.content ? 
      state.pageDetailState.content : state.pageDetailPreviewState.content,
    status: state.pageDetailState.status ? 
      state.pageDetailState.status : state.pageDetailPreviewState.status,
    statusPreview: state.pageDetailPreviewState.status,
    meta_description: state.pageDetailState.meta_description ? 
      state.pageDetailState.meta_description : state.pageDetailPreviewState.meta_description,
    meta_title: state.pageDetailState.meta_title ? 
      state.pageDetailState.meta_title : state.pageDetailPreviewState.meta_title,
    template: state.pageDetailState.template ? 
      state.pageDetailState.template : state.pageDetailPreviewState.template,
    contentNode: state.pageDetailState.content ? 
      state.pageDetailState.content : state.pageDetailPreviewState.content,
    redirection: state.pageDetailState.redirection ? 
      state.pageDetailState.redirection : state.pageDetailPreviewState.redirection,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchPageDetail: (slug: string) => dispatch(fetchPageDetail(slug)),
    fetchPageDetailPreview: (id: number) => dispatch(fetchPageDetailPreview(id)),
  })
)(PageDetail);
